import script from "./ShakyoMyCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoMyCode.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoMyCode.vue?vue&type=style&index=0&id=8c9ec8f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c9ec8f4"]])

export default __exports__